import { type Observable as ObservableType, Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/ignoreElements';
import { dismissMigrationModal } from '../../rest/column-migration-graphql/index.tsx';
import {
	getRapidViewId,
	getBaseUrl,
	getRequestColumnMigration,
} from '../../state/selectors/app/index.tsx';
import { isDialogOpen } from '../../state/selectors/board-issue-move/index.tsx';
import { canEditBoardConfig } from '../../state/selectors/permissions/index.tsx';
import { isBacklogWithSprints } from '../../state/selectors/sprints/index.tsx';
import type { State } from '../../state/types.tsx';

const shouldCheckForDialog = (state: State): boolean => {
	const canEdit = canEditBoardConfig(state);

	const isAlreadyOpen = isDialogOpen(state);
	const isSprintsEnabled = isBacklogWithSprints(state);
	return canEdit && !isAlreadyOpen && !isSprintsEnabled;
};

export const shouldDisplayDialog = (state: State): ObservableType<boolean> => {
	if (shouldCheckForDialog(state)) {
		return Observable.of(getRequestColumnMigration(state));
	}
	return Observable.of(false);
};

export const dismissDialog = (state: State): ObservableType<void> => {
	const rapidViewId = getRapidViewId(state);
	const baseUrl = getBaseUrl(state);
	return dismissMigrationModal(baseUrl, rapidViewId).ignoreElements();
};
